var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"distribution-editor"},[_c('a-modal',{staticClass:"modal-overflow-visible",attrs:{"centered":"","ok-text":_vm.$t('accept'),"cancel-text":_vm.$t('reject')},on:{"ok":_vm.handleTimezoneOkClick,"cancel":_vm.handleCancel},model:{value:(_vm.timezoneModalOpen),callback:function ($$v) {_vm.timezoneModalOpen=$$v},expression:"timezoneModalOpen"}},[_c('select-input',{staticClass:"w-full",attrs:{"setup":{
        'func': _vm.modelSetter,
        'args': {
          'model': this,
          'key': 'currentTimezone',
          'options': _vm.timezoneList,
          'clearable': false,
          'disabled': _vm.disabled
        }
      }}})],1),_c('a-card',{attrs:{"title":_vm.$t((_vm.action + "_distribution")).toString()}},[_c('text-input',{staticClass:"distribution-item__description mt-0",attrs:{"setup":{
        'func': _vm.modelSetter,
        'args': {
          'model': _vm.distributionModel,
          'key': 'description',
          'prefix': 'distribution_',
          'disabled': _vm.disabled
        }
      }}}),_c('number-input',{attrs:{"setup":{
        'func': _vm.modelSetter,
        'args': {
          'model': _vm.distributionModel,
          'key': 'limit',
          'prefix': 'distribution_',
          'disabled': _vm.disabled,
          'inline': !_vm.isMobile()
        }
      }}}),_c('multi-message-editor-with-media-input',{attrs:{"setup":{
        'func': _vm.modelSetter,
        'args':{
          'model': _vm.distributionModel.content,
          'key':'templates',
          'prefix': 'distribution_',
          'validation': 'required',
          'availableButtonsTypes': _vm.messageEditorProps.defaultMessageEditorButtons,
          'targetToUpload': {
            'target': 'target',
            'target_id': _vm.messageEditorProps.board_key,
          },
          'hasMedia': true,
          'base-api-url': 'api.presscode.app/cabinet',
          'buttonsHelpView': _vm.messageEditorProps.editorButtonsHelpView,
          'disabled': _vm.disabled,
          'customMediaTypes': _vm.messageEditorProps.customMediaTypes,
          'placeholders': _vm.placeholders
        }
      }}}),_c('distribution-conditions',{staticClass:"mx-2 mt-5",attrs:{"conditions":_vm.distributionModel.conditions,"labels-options":_vm.labelsOptions,"disabled":_vm.disabled,"utm-sources":_vm.utmSources,"get-users-info":_vm.getUsersInfo,"get-channels-info":_vm.getChannelsInfo,"targets":_vm.targets,"pre-check-distribution":_vm.preCheckDistribution,"pre-check-count":_vm.preCheckCount,"is-pre-check-loading":_vm.isPreCheckLoading},on:{"input":_vm.conditionsChange}}),_c('div',{staticClass:"flex md:flex-row md:justify-between md:items-end flex-col mt-5"},[_c('div',{staticClass:"distribution-editor__time"},[_c('date-picker-input',{staticClass:"mb-0",attrs:{"setup":{
            'func': _vm.modelSetter,
            'args': {
              'model': _vm.distributionModel,
              'key': 'time',
              'clearable': false,
              'format': _vm.PickerFormat.DateTime,
              'disabled': _vm.disabled,
              'prefix': 'distribution_'
            }
          }}}),_c('div',{staticClass:"mt-2 flex items-center gap-2"},[_c('a-button',{attrs:{"icon":"global","type":"primary","disabled":_vm.disabled},on:{"click":function($event){_vm.timezoneModalOpen = true}}}),_c('div',[_vm._v(" "+_vm._s(_vm.$t('current_distribution_timezone'))+" "),_c('span',{staticClass:"font-semibold text-primary cursor-pointer hover:opacity-75",attrs:{"disabled":_vm.disabled},on:{"click":function($event){_vm.timezoneModalOpen = true}}},[_vm._v(" "+_vm._s(_vm.distributionModel.timezone)+" ")])])],1)],1),_c('div',{staticClass:"flex flex-col md:flex-row mt-2 md:mt-0 gap-2"},[(!_vm.disabled)?_c('a-button',{staticClass:"btn-success",attrs:{"disabled":_vm.isSaveButtonDisabled},on:{"click":_vm.prepareForSave}},[_vm._v(" "+_vm._s(_vm.$t('distribution_item_save'))+" ")]):_vm._e(),(!_vm.disabled)?_c('a-button',{attrs:{"type":"primary","disabled":_vm.isRunNowButtonDisabled},on:{"click":_vm.startNow}},[_vm._v(" "+_vm._s(_vm.$t('distribution_item_start_now'))+" ")]):_vm._e(),_c('a-button',{attrs:{"type":"danger"},on:{"click":_vm.goToList}},[_vm._v(" "+_vm._s(_vm.action === _vm.DistributionEditorAction.watch ? _vm.$t('back_button') : _vm.$t('cancel_button'))+" ")])],1)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }